import { getSearchKreProduk } from "../../../core/services/finance/loan.service";
import { useQuery } from "@tanstack/react-query";
export const useGetSearchKreProduk = (searchParams) => {
    return useQuery({
        queryKey: ["finance", "kreproduk", searchParams],
        queryFn: () => getSearchKreProduk(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
